import { useSelector } from "react-redux";


export const useDrivingRangeLists = () => useSelector((state) => state.DrivingRange);
export const useAssociatedCourseData = () => useSelector((state) => state.associatedCourseData);
export const useRangeInfoDetails = () => useSelector((state) => state.RangeInfo.range_details_data);
export const useAssociatedCoursesOfRangeDetails = () => useSelector((state) => state.RangeInfo.showCoursesOfRangeDetails);